import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { createListenerEffect, selectApp, writeLocalStorage } from '@socialive/common';
import { selectPreferences } from '~/selectors';
import { setDefaultPreferences, setPreference } from '~/slice';

export const effect = createListenerEffect(
  'preferences/persistPreferences<Listener>',
  async (action, { dispatch, getState, trigger }) => {
    const app = selectApp(getState());
    const preferences = selectPreferences(getState());

    writeLocalStorage(app, preferences);
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: isAnyOf(setPreference, setDefaultPreferences),
  effect,
});

export default middleware;
